import { render } from "./SingleRecordView.vue?vue&type=template&id=1ffa487b"
import script from "./SingleRecordView.vue?vue&type=script&lang=js"
export * from "./SingleRecordView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/loaders/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
